import { render } from "./CalibrationView.vue?vue&type=template&id=10b4bc6b&scoped=true"
import script from "./CalibrationView.vue?vue&type=script&lang=js"
export * from "./CalibrationView.vue?vue&type=script&lang=js"

import "./CalibrationView.vue?vue&type=style&index=0&id=10b4bc6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b4bc6b"]])

export default __exports__